import React from "react";
import moment from "moment";
import auth from "../../../../common/utility/auth";
import global from "../../../../common/utility/global";
import BarcodeReader from "react-barcode-reader";

import TextArea from 'antd/lib/input/TextArea';
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
} from "antd";
import {
  FORMAT_NUMBER,
  FORMAT_3DECIMALS,
  GREATER_THAN_ZERO
} from "../../../../common/types/regularExpresionType";
import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
  IMPUESTO_SELECTIVO_CONSUMO_VENTA,
  PORCENTAJE_PERCEPCION,
  VALIDAR_STOCK
} from "../../../../common/types/parametroType";

import Footer from "./Footer";


import dialog from "../../../../common/utility/dialog";

import Productos from "./Productos";


const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModalCompra extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      result: "No result",
    };
    this.handleScan = this.handleScan.bind(this);

  }


  handleScan(data) {
    debugger
    this.props.onScanerProduct(
      data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue
    );
  }

  handleError(err) {
    alert("error");
    console.error(err);
  }


  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };

  findDaysAndDates = (property, value) => {
    if (property === "diasVencimiento") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const diasVencimiento = parseInt(value);
      this.props.form.setFieldsValue({
        fechaVencimientoStr: fecha.add("days", diasVencimiento),
      });
    }

    if (property === "fechaVencimientoStr") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const fechaVencimiento = moment(value, "DD/MM/YYYY");
      this.props.form.setFieldsValue({
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  completeDocumento = (e) => {
    var value = e.target.value;
    if (value.length === 0) return;

    var zeros = "";
    for (let index = 0; index < 8 - value.length; index++) {
      zeros += "0";
    }
    this.props.form.setFieldsValue({ documento: zeros + value }, () => {
      this.props.form.validateFields(["documento"], { force: true });
    });
  };

  documentoCustomValidation = (rule, value, callback) => {
    if (value === "00000000") callback("Documento no válido");

    callback();
  };


  handleSearchAutocompleteProveedor = async (value) => {
    const result = this.props.formValues.proveedores
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ proveedores: result });
  };

  handleChangeAutocompleteProveedor = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoProveedor: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idProveedor",
          element.props.data.idEntidad,
          this.props.form
        );
      }
    );
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  validate_fechaMayorQue(fechaInicial, fechaFinal) {
    var valuesStart = fechaInicial.split("/");
    var valuesEnd = fechaFinal.split("/");

    // Verificamos que la fecha no sea posterior a la actual
    var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
    var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);
    if (dateStart >= dateEnd) {
      return 0;
    }
    return 1;
  }

  handleCalculateDetail = (row, property, value, numberDecimals) => {

    var newValue = this.fetchNewValue(value, numberDecimals);
    var params = auth.user().parametros;

    /********* Datos de parametro ******/
    var porcentajeIGV = 18;
    var centaje = 0;
    centaje = 1 + (porcentajeIGV / 100);

    var porcentajeISC = parseFloat(
      params.filter(
        (m) => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA
      )[0].valor
    );
    var flagPrecioIncluyeIGV = false;
    var flagValidarStock =
      params.filter(
        (m) => m.abreviatura === VALIDAR_STOCK
      )[0].valor === "1"
        ? true
        : false;

    /*********** Datos por fila ********/

    var flagChangeTotal = false;
    var flagAfecto =
      property === "arrFlagAfecto"
        ? value
        : this.props.form.getFieldValue(`arrFlagAfecto[${row.identifier}]`);
    var flagExonerado =
      property === "arrFlagExonerado"
        ? value
        : this.props.form.getFieldValue(`arrFlagExonerado[${row.identifier}]`);
    var flagGratuito =
      property === "arrFlagGratuito"
        ? value
        : this.props.form.getFieldValue(`arrFlagGratuito[${row.identifier}]`);
    var flagISC =
      property === "arrFlagISC"
        ? value
        : this.props.form.getFieldValue(`arrFlagISC[${row.identifier}]`);
    var precioUnitario = this.fetchFieldValue(
      row.identifier,
      "arrPrecioUnitario"
    );
    var porcentajeMargenComercial = this.fetchFieldValue(
      row.identifier,
      "arrPorcentajeMargenComercial"
    );

    var precioPromedio = this.fetchFieldValue(
      row.identifier,
      "arrPrecioPromedio"
    );

    var fechaVencimiento = property === "arrFechaVencimiento" ? value : this.props.form.getFieldValue(`arrFechaVencimiento[${row.identifier}]`);
    var numeroRegistroSanitario = property === "arrNumeroRegistroSanitario" ? value : this.props.form.getFieldValue(`arrNumeroRegistroSanitario[${row.identifier}]`);
    //var fechaProduccion = property === "arrFechaProduccion" ? value : this.props.form.getFieldValue(`arrFechaProduccion[${row.identifier}]`);
    var flagVencimiento = row.flagVencimiento;// property === "arrFlagVencimiento" ? value : this.props.form.getFieldValue(`arrFlagVencimiento[${row.identifier}]`);


    var valorUnitario = this.fetchFieldValue(
      row.identifier,
      "arrPrecio"
    );

    if (property === "arrFlagAfecto") {
      valorUnitario = value ? (precioUnitario * centaje) : precioUnitario;

    }
    if (property === "arrFlagExonerado") {
      valorUnitario = precioUnitario;

    }

    if (flagAfecto && !flagExonerado) {

      if (property === "arrPrecio") {
        precioUnitario = (valorUnitario / centaje)

      }

      if (property === "arrPrecioUnitario") {
        valorUnitario = (precioUnitario * centaje)

      }

    } else {

      if (property === "arrPrecio") {
        precioUnitario = valorUnitario
        valorUnitario = precioUnitario
      }

      if (property === "arrPrecioUnitario") {
        valorUnitario = parseFloat(value);
        precioUnitario = valorUnitario
      }
    }




    var cantidad = this.fetchFieldValue(row.identifier, "arrCantidad");
    var porcentajeDescuento = this.fetchFieldValue(
      row.identifier,
      "arrPorcentajeDescuento"
    );
    var importeDescuento = this.fetchFieldValue(
      row.identifier,
      "arrImporteDescuento"
    );
    var total = this.fetchFieldValue(row.identifier, "arrTotal");

    if (porcentajeDescuento > 100) {
      message.warning("El porcentaje de descuento no puedo ser mayor a 100%");
      return;
    }

    /*********** Datos por fila (bloquear checks) ********/
    if (flagGratuito && property == "arrFlagGratuito") {
      flagAfecto = false;
      flagISC = false;
      flagExonerado = false;
    }

    if (flagAfecto && property == "arrFlagAfecto") {
      flagGratuito = false;
      flagExonerado = false;
      flagISC = false;
    }

    if (flagExonerado && property == "arrFlagExonerado") {
      flagAfecto = false;
      flagGratuito = false;
      flagISC = false;
    }

    /*********** Calculo precios unitarios ********/
    var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
    var precioUnitarioSinIGV = flagPrecioIncluyeIGV
      ? precioUnitario / divisorCalculoSubTotal
      : precioUnitario;

    /*********** Calculo por ISC ********/
    var importeISC = flagISC ? precioUnitarioSinIGV * (porcentajeISC / 100) : 0;
    var precioUnitarioISC = flagISC ? precioUnitarioSinIGV + importeISC : 0;
    var totalDetalle = flagISC
      ? cantidad * precioUnitarioISC
      : cantidad * precioUnitarioSinIGV;

    /*********** Calculo totales ********/
    var subTotal = totalDetalle;
    var igv = parseFloat(
      (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0)
    );
    total = parseFloat((subTotal + igv));

    if (property === "arrTotal" && parseFloat(newValue) !== total) {
      flagISC = false;
      importeISC = 0;
      precioUnitarioISC = 0;
      flagChangeTotal = true;

      /*********** Calculo totales ********/
      total = parseFloat(value);
      porcentajeDescuento = 0;
      importeDescuento = 0;
      subTotal = parseFloat(
        (flagAfecto ? total / (1 + porcentajeIGV / 100) : total)
      );

      /*********** Calculo por ISC ********/
      totalDetalle = flagISC ? cantidad * precioUnitarioISC : subTotal;

      /*********** Calculo Cantidad ********/
      cantidad = parseFloat((subTotal / precioUnitarioSinIGV).toFixed(3));
      if (cantidad === 0) cantidad = 1;

      /*********** Calculo IGV ********/
      igv = flagAfecto ? subTotal * (porcentajeIGV / 100) : 0;
    }

    /*********** Calculo descuentos ********/
    if (importeDescuento > 0 || porcentajeDescuento > 0) {
      var calculoimporteDescuento = 0;
      if (flagPrecioIncluyeIGV) {
        calculoimporteDescuento = parseFloat(
          (total * (porcentajeDescuento / 100)).toFixed(2)
        );
      } else {
        calculoimporteDescuento = parseFloat(
          (total * (porcentajeDescuento / 100)).toFixed(2)
        );
      }

      if (
        importeDescuento !== calculoimporteDescuento &&
        property === "arrImporteDescuento"
      )
        porcentajeDescuento = 0;
      else importeDescuento = calculoimporteDescuento;


      if (flagPrecioIncluyeIGV) {
        total = total - importeDescuento;

        if (flagAfecto) {
          subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
          igv = total - subTotal;
          totalDetalle = subTotal;
        } else {
          subTotal = total;
          igv = 0;
          totalDetalle = subTotal;
        }
      } else {
        subTotal = subTotal - importeDescuento;

        if (flagAfecto) {
          var igv = parseFloat(
            (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          total = parseFloat((subTotal + igv).toFixed(2));
        } else {
          total = subTotal;
          subTotal = subTotal;
          igv = 0;
          totalDetalle = subTotal;
        }
      }




    }

    /*********** Calculo gratuito ********/
    if (flagGratuito) {
      porcentajeDescuento = 0;
      importeDescuento = 0;
      igv = 0;
      subTotal = 0;
      total = 0;
    }

    /*********** Actualizar Detalle de Productos ********/
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });
    var _fecha = (fechaVencimiento == null || flagVencimiento == false) ? null : fechaVencimiento.format('DD/MM/YYYY')

    detalleProductosFilter.push({
      identifier: row.identifier,
      nombre: this.props.form.getFieldValue(`arrNombre[${row.identifier}]`),
      idProducto: row.idProducto,
      codigoBarra: row.codigoBarra,
      idTipoProducto: row.idTipoProducto,
      cantidad,
      precioUnitarioSinIGV,
      precioUnitario: valorUnitario,
      valorUnitario,
      igv,
      totalDetalle,
      numeroRegistroSanitario: numeroRegistroSanitario == undefined ? null : numeroRegistroSanitario,
      fechaVencimientoStr: fechaVencimiento == undefined ? null : _fecha,
      fechaProduccionStr: null,// fechaProduccion == null ? null : fechaProduccion.format('DD/MM/YYYY'),
      flagVencimiento,
      // porcentajeDescuento,
      // importeDescuento,
      numeroLote: this.props.form.getFieldValue(`arrLote[${row.identifier}]`),
      flagAfecto,
      flagExonerado,
      flagISC,
      flagOtrosImpuesto: false, // OMITIDO POR EL MOMENTO
      flagGratuito,
      flagChangeTotal,
      total,
      subTotal
    });

    /*********** Re-Calcular Suma SubTotal ********/

    var sumaTotalAfecto = this.fetchSumaTotalAfecto(
      row.identifier,
      flagAfecto,
      flagGratuito,
      total
    );
    var sumaTotalInafecto = this.fetchSumaTotalInafecto(
      row.identifier,
      flagAfecto,
      flagGratuito,
      flagExonerado,
      total
    );

    var fetchSumaTotalExonerado = this.fetchSumaTotalExonerado(
      row.identifier,
      flagExonerado,
      flagGratuito,
      total
    );

    /*********** Calculo suma detalle ********/
    var sumaImporteDescuento = this.fetchFieldValueSum(
      row.identifier,
      "arrImporteDescuento",
      importeDescuento
    );

    var sumaIsc = this.fetchFieldValueSum(
      row.identifier,
      "arrIsc",
      cantidad === 0 ? 0 : importeISC
    );
    var sumaTotal = parseFloat(this.fetchFieldValueSum(row.identifier, "arrTotal", total).toFixed(2));
    var sumaSubTotal = parseFloat(
      (sumaTotalAfecto / divisorCalculoSubTotal + (sumaTotalInafecto + fetchSumaTotalExonerado)).toFixed(2)
    );

    var sumaIgv = sumaTotal - sumaSubTotal
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    importeDetraccion = parseFloat(importeDetraccion.toFixed(0));
    var totalDetraccion = sumaTotal - importeDetraccion;

    var valueDate = flagVencimiento == false ? null : fechaVencimiento == null ? null : fechaVencimiento.format('DD/MM/YYYY');
    if (flagVencimiento) {
      valueDate = moment(global.fetchCurrentDateStr(), "DD/MM/YYYY");
    }

    this.props.form.setFieldsValue({
      // sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      [`arrFlagAfecto[${row.identifier}]`]: flagAfecto,
      [`arrFlagExonerado[${row.identifier}]`]: flagExonerado,
      [`arrFlagGratuito[${row.identifier}]`]: flagGratuito,
      [`arrFechaVencimiento[${row.identifier}]`]: valueDate,

      [`arrFlagISC[${row.identifier}]`]: flagISC,
      [`arrIsc[${row.identifier}]`]: cantidad === 0 ? 0 : importeISC,
      [`arrPrecioUnitario[${row.identifier}]`]: precioUnitario.toFixed(5),
      [`arrPrecio[${row.identifier}]`]: valorUnitario.toFixed(5),
      [`arrCantidad[${row.identifier}]`]: cantidad.toFixed(3),
      [`arrTotalDetalle[${row.identifier}]`]: totalDetalle.toFixed(2),
      [`arrSubTotal[${row.identifier}]`]: subTotal.toFixed(2),
      [`arrIgv[${row.identifier}]`]: igv.toFixed(2),
      [`arrTotal[${row.identifier}]`]: total.toFixed(2),
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });
  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);

    return 0;
  };

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };

  fetchSumaTotalAfecto = (
    identifier,
    paramFlagAfecto,
    paramFlagGratuito,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagAfecto =
        identifier === key
          ? paramFlagAfecto
          : this.props.form.getFieldValue("arrFlagAfecto")[key];
      var flagGratuito =
        identifier === key
          ? paramFlagGratuito
          : this.props.form.getFieldValue("arrFlagGratuito")[key];
      if (flagAfecto && !flagGratuito) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  fetchSumaTotalInafecto = (
    identifier,
    paramFlagAfecto,
    paramFlagGratuito,
    paramFlagExonerado,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagAfecto =
        identifier === key
          ? paramFlagAfecto
          : this.props.form.getFieldValue("arrFlagAfecto")[key];
      var flagGratuito =
        identifier === key
          ? paramFlagGratuito
          : this.props.form.getFieldValue("arrFlagGratuito")[key];
      var flagExonerado =
        identifier === key
          ? paramFlagExonerado
          : this.props.form.getFieldValue("arrFlagExonerado")[key];
      if (!flagAfecto && !flagGratuito && !flagExonerado) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  fetchSumaTotalExonerado = (
    identifier,
    paramFlagExonerado,
    paramFlagGratuito,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagExonerado =
        identifier === key
          ? paramFlagExonerado
          : this.props.form.getFieldValue("arrFlagExonerado")[key];
      var flagGratuito =
        identifier === key
          ? paramFlagGratuito
          : this.props.form.getFieldValue("arrFlagGratuito")[key];
      if (flagExonerado && !flagGratuito) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };

  //#region  [MEDIO DE PAGO]


  handleChangeTotals = (property, value) => {

    if (property === "flagPercepcion" && value) {
      var porcentajePercepcion = parseFloat(
        auth
          .user()
          .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
          .valor
      );
      var importePercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) *
        (porcentajePercepcion / 100);
      var totalPercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) + importePercepcion;

      this.props.form.setFieldsValue({
        porcentajePercepcion,
        importePercepcion,
        totalPercepcion,
        flagDetraccion: false,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,
        idDetraccion: undefined,
      });
    }

    if (property === "flagDetraccion" && value) {
      this.props.form.setFieldsValue(
        {
          flagPercepcion: false,
        },
        () => {
          this.props.form.validateFields(["idDetraccion"], { force: true });
        }
      );
    }

    if (property === "idDetraccion") {

      var importeDetraccion = parseFloat((this.fetchFieldValueSum("", "arrTotal", 0) * (value / 100)).toFixed(0));
      var totalDetraccion = parseFloat((this.fetchFieldValueSum("", "arrTotal", 0) - importeDetraccion).toFixed(2));

      this.props.form.setFieldsValue({
        flagPercepcion: false,
        porcentajePercepcion: 0,
        importePercepcion: 0,
        totalPercepcion: 0,
        porcentajeDetraccion: value,
        importeDetraccion,
        totalDetraccion,
      });
    }

    if (
      property === "porcentajeDescuentoGlobal" ||
      property === "importeDescuentoGlobal"
    ) {

      /********  PARAMETROS ********/
      var params = auth.user().parametros;
      var flagPrecioIncluyeIGV =
        params.filter(
          (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
        )[0].valor === "1"
          ? true
          : false;
      var porcentajeIGV = 18;
      /******** VARIABLES ********/
      var totalDetalle = 0;
      var total = this.fetchFieldValueSum("", "arrTotal", 0);
      var subTotal = this.fetchFieldValueSum("", "arrSubTotal", 0);
      var calculoimporteDescuentoGlobal = 0;
      var importeDescuentoGlobal = parseFloat(
        this.props.form.getFieldValue("importeDescuentoGlobal")
      );
      var porcentajeDescuentoGlobal = parseFloat(
        this.props.form.getFieldValue("porcentajeDescuentoGlobal")
      );
      var igv = parseFloat(this.props.form.getFieldValue("igv"));
      var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;

      if (property === "porcentajeDescuentoGlobal") {
        porcentajeDescuentoGlobal = parseFloat(value);
      } else {
        importeDescuentoGlobal = parseFloat(value);
      }

      /******** CALCULOS DESCUENTO ********/
      if (flagPrecioIncluyeIGV) {
        calculoimporteDescuentoGlobal = parseFloat(
          (total * (porcentajeDescuentoGlobal / 100)).toFixed(2)
        );
      } else {
        calculoimporteDescuentoGlobal = parseFloat(
          (total * (porcentajeDescuentoGlobal / 100)).toFixed(2)
        );
      }

      if (
        porcentajeDescuentoGlobal !== 0 &&
        property === "porcentajeDescuentoGlobal"
      )
        importeDescuentoGlobal = calculoimporteDescuentoGlobal;

      if (importeDescuentoGlobal !== 0 && property === "importeDescuentoGlobal")
        porcentajeDescuentoGlobal = 0;

      /******** CALCULOS TOTALES ********/

      if (flagPrecioIncluyeIGV) {
        if (importeDescuentoGlobal > total || importeDescuentoGlobal === 0) {
          importeDescuentoGlobal = 0.0;
          porcentajeDescuentoGlobal = 0.0;
        }

        total = total - importeDescuentoGlobal;

        if (igv !== 0) {
          subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
          igv = total - subTotal;
          totalDetalle = subTotal;
        } else {
          subTotal = total;
          igv = 0;
          totalDetalle = subTotal;
        }
      } else {
        if (importeDescuentoGlobal > subTotal || importeDescuentoGlobal === 0) {
          importeDescuentoGlobal = 0.0;
          porcentajeDescuentoGlobal = 0.0;
        }
        subTotal = subTotal - importeDescuentoGlobal;

        if (igv !== 0) {
          igv = parseFloat(
            (igv !== 0 ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          total = parseFloat((subTotal + igv).toFixed(2));
        } else {
          total = subTotal;
          subTotal = subTotal;
          igv = 0;
          totalDetalle = subTotal;
        }
      }

      /******** SETEAR CALCULOS TOTALES ********/
      this.props.form.setFieldsValue({
        sumaTotal: total,
        sumaIgv: igv,
        sumaSubTotal: subTotal,
        sumaTotalDetalle: totalDetalle,
        importeDescuentoGlobal: parseFloat(importeDescuentoGlobal.toFixed(2)),
        porcentajeDescuentoGlobal: parseFloat(
          porcentajeDescuentoGlobal.toFixed(2)
        ),
      });
    }
  };



  handleOk = (e) => {
    e.preventDefault();
    debugger
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);

      if (values.detalleProductos.length == 0) {
        dialog.error("Agrega detalle de Productos !");
        return false;
      }


      if (!err) {
        const porcentajeIGV = 18;

        const data = {
          id: values.id,
          idTipoComprobante: values.idTipoComprobante.key,
          idProveedor: values.idProveedor.key,
          idEstablecimientoProveedor: values.idEstablecimientoProveedor.key,
          idVendedor: values.idVendedor === undefined ? 0 : values.idVendedor.key,
          idAlmacen: values.idAlmacen === undefined ? 0 : values.idAlmacen.key,
          idMoneda: values.idMoneda.key,
          idFormaPago: 1,//contado
          idEstablecimiento: values.idEstablecimiento.key,
          idDetraccion: values.idDetraccion === undefined ? 0 : values.idDetraccion.key,
          idUsuarioRegistro: values.idUsuarioRegistro,
          serie: values.serie.toUpperCase(),
          documento: values.documento,
          idTipoAlmacen: values.idTipoAlmacen === undefined ? 0 : values.idTipoAlmacen.key,
          idMotivo: values.idMotivo === undefined ? 0 : values.idMotivo.key,
          idTipoActividad: values.idTipo === undefined ? 0 : values.idTipo.key,
          otroImpuesto: false,
          porcentajeIGV: porcentajeIGV,

          importeDetraccion: values.importeDetraccion === undefined ? 0 : values.importeDetraccion,
          flagCajaChica: true,
          fechaDocumentoStr: values.fechaDocumentoStr.format("DD/MM/YYYY"),
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          fechaVencimientoStr: values.fechaVencimientoStr.format("DD/MM/YYYY"),
          diasVencimiento: parseInt(values.diasVencimiento),
          fechaRecepcionStr: values.fechaRecepcionStr.format("DD/MM/YYYY"),
          tipoCambio: parseFloat(values.tipoCambio),
          observacion: values.observacion,
          flagExportacion: values.flagExportacion,
          flagPercepcion: values.flagPercepcion,
          flagDetraccion: values.flagDetraccion,
          idPendiente: 0,
          idClasificacion: values.idClasificacion.key,
          total: values.sumaTotal,
          listaCompraDetalle: values.detalleProductos,
        };


        if (data.idFormaPago == 1) {
          data.listaComprobanteCuota = new Array();
        }
        this.props.onSave(data, this.props.form);
      }
    });
  };




  handleRemoverProducto = (row) => {
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });


    var sumaIsc = this.fetchFieldValueSum(row.identifier, "arrIsc", 0);
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", 0);
    var sumaSubTotal = this.fetchFieldValueSum(
      row.identifier,
      "arrSubTotal",
      0
    );
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;

    this.props.form.setFieldsValue({
      // sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    this.props.onRemoverProducto(row, this.props.form);
  };




  render() {
    const {
      getFieldDecorator,
      setFieldsValue,
      getFieldValue,
    } = this.props.form;

    getFieldDecorator("id", { initialValue: this.props.formValues.id });

    getFieldDecorator("idTipoComprobante", { initialValue: this.props.formValues.idTipoComprobante });

    getFieldDecorator("proveedores", {
      initialValue: this.props.formValues.proveedores.filter((m) => {
        return m.id === this.props.formValues.idProveedor;
      }),
    });

    getFieldDecorator("sumaTotalDetalle", {
      initialValue: this.props.formValues.sumaTotalDetalle,
    });
    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaIsc", {
      initialValue: this.props.formValues.sumaIsc,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("detalleProductos", {
      initialValue: this.props.formValues.detalleProductos,
    });
    getFieldDecorator("porcentajeDetraccion", {
      initialValue: this.props.formValues.porcentajeDetraccion,
    });
    getFieldDecorator("importeDetraccion", {
      initialValue: this.props.formValues.importeDetraccion,
    });
    getFieldDecorator("totalDetraccion", {
      initialValue: this.props.formValues.totalDetraccion,
    });
    getFieldDecorator("porcentajePercepcion", {
      initialValue: this.props.formValues.porcentajePercepcion,
    });
    getFieldDecorator("importePercepcion", {
      initialValue: this.props.formValues.importePercepcion,
    });
    getFieldDecorator("totalPercepcion", {
      initialValue: this.props.formValues.totalPercepcion,
    });

    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });

    getFieldDecorator("idPendiente", {
      initialValue: this.props.formValues.idPendiente,
    });

    getFieldDecorator("flagCuota", {
      initialValue: false,
    });

    getFieldDecorator("flagMetodoPago", {
      initialValue: false,
    });


    getFieldDecorator("idFormaPago", {
      initialValue: this.props.formValues.idFormaPago,
    });

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? `Registrar Comprobante Compra`
            : `Modificar Comprobante Compra`
        }
        visible={this.props.visible}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        footer={[
          <Button key="cancel" onClick={this.handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="ok"
            type="primary"
            loading={this.props.formValues.saveLoading}
            onClick={this.handleOk}
          >
            Guardar
          </Button>,
        ]}
        style={{ top: 30 }}
        width="1100px"
      >

        <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

        <Form>
          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha / Tipo de Cambio">
                <InputGroup compact>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        }
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("tipoCambio", {
                      initialValue: parseFloat(
                        this.props.formValues.tipoCambio
                      ).toFixed(3),
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_3DECIMALS),
                          message: "Formato decimal incorrecto (0.000)",
                        },
                        {
                          required: true,
                          pattern: new RegExp(GREATER_THAN_ZERO),
                          message: "Campo Obligatorio"
                        }
                      ],
                    })(
                      <Input
                        className="text-right second-input"
                        placeholder="Ingresar Tipo de Cambio"
                        autoComplete="off"
                        onBlur={(e) =>
                          this.handleCompleteDecimals(
                            "tipoCambio",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Días / Fecha de Vencimiento">
                <InputGroup compact>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("diasVencimiento", {
                      initialValue: this.props.formValues.diasVencimiento,
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_NUMBER),
                          message: "Formato incorrecto",
                        },
                      ],
                    })(
                      <Input
                        style={{ textAlign: "right" }}
                        placeholder="Ingresar días de vencimiento"
                        autoComplete="off"
                        className="first-input"
                        onBlur={(e) =>
                          this.findDaysAndDates(
                            "diasVencimiento",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaVencimientoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaVencimientoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        className="second-input"
                        onChange={(moment, value) =>
                          this.findDaysAndDates("fechaVencimientoStr", value)
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Registro">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaDocumentoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaDocumentoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de recepción"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 form-group">
              <Form.Item label="Proveedor">
                <InputGroup compact>
                  <Form.Item style={{ width: "20%" }}>
                    {getFieldDecorator("documentoProveedor", {
                      initialValue: this.props.formValues.documentoProveedor,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                          whitespace: true,
                        },
                      ],
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        loading={this.props.formValues.proveedorLoading}
                        onSearch={(value) =>
                          this.props.onBuscarProveedor(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "80%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("idProveedor", {
                        initialValue: this.props.formValues.idProveedor
                          ? { key: this.props.formValues.idProveedor }
                          : undefined,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                          },
                        ],
                      })(
                        <Select
                          showSearch
                          labelInValue
                          placeholder={"Búsqueda de Proveedor"}
                          optionFilterProp="children"
                          showArrow={false}
                          onSearch={this.handleSearchAutocompleteProveedor}
                          onChange={this.handleChangeAutocompleteProveedor}
                        >
                          {getFieldValue("proveedores").map((item) => (
                            <Option key={item.id} value={item.id} data={item}>
                              <Tag>{item.tipoDocumentoNombre}</Tag>
                              {`${item.nombre}`}
                            </Option>
                          ))}
                        </Select>
                      )}

                    </InputGroup>
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Recepción">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaRecepcionStr", {
                      initialValue: moment(
                        this.props.formValues.fechaRecepcionStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de recepción"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
          </div>


          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Dirección">
                {getFieldDecorator("idEstablecimientoProveedor", {
                  initialValue: this.props.formValues
                    .idEstablecimientoProveedor
                    ? {
                      key: this.props.formValues
                        .idEstablecimientoProveedor,
                    }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Direccion"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.direcciones.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre + " - " + item.direccion}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


            <div className="col-md-4 form-group">
              <Form.Item label="Moneda">
                {getFieldDecorator("idMoneda", {
                  initialValue: this.props.formValues.idMoneda
                    ? { key: this.props.formValues.idMoneda }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Moneda"}
                    optionFilterProp="children"
                    disabled
                    onChange={(option) => {
                      this.props.form.setFieldsValue(
                        {
                          idListaPrecio: undefined,
                        },
                        () => {
                          this.props.onChange("idMoneda", option.key);
                        }
                      );
                    }}
                  >
                    {this.props.formValues.monedas.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>



            <div className="col-md-4 form-group">
              <Form.Item label="Tipo">
                {getFieldDecorator("idTipo", {
                  initialValue: this.props.formValues.idTipo
                    ? { key: this.props.formValues.idTipo }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Tipo"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idTipo",
                        option.key,
                        this.props.form
                      )
                    }
                    }
                  >
                    {this.props.formValues.tipo.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Clasificación">
                {getFieldDecorator("idClasificacion", {
                  initialValue: this.props.formValues.idClasificacion
                    ? { key: this.props.formValues.idClasificacion }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Clasificacion"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idClasificacion",
                        option.key,
                        this.props.form
                      )
                    }
                    }
                  >
                    {this.props.formValues.clasificacion.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.descripcion}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Tipo Comprobante">
                {getFieldDecorator("idTipoComprobante", {
                  initialValue: this.props.formValues.idTipoComprobante
                    ? { key: this.props.formValues.idTipoComprobante }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Tipo de Comprobante"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange(
                        "idTipoComprobante",
                        option.key,
                        this.props.form
                      )
                    }
                    }
                  >
                    {this.props.formValues.tiposComprobante.map((item) => (
                      item.codigoSunat == "01" || item.codigoSunat == "03" ?
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option> : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: this.props.formValues.idTipoComprobante == 6 ? false : true,
                          message: "Requerido",
                          whitespace: true,
                        },
                        // {
                        //   validator: this.serieCustomValidation,
                        // },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        maxLength={4}
                        disabled={this.props.formValues.idTipoComprobante == 6}
                        style={{ textTransform: "uppercase" }}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                      rules: [
                        {
                          validator: this.documentoCustomValidation,
                        },
                        {
                          required: true,
                          message: "Requerido",
                          whitespace: true,
                        }
                      ],
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        onBlur={this.completeDocumento}
                        maxLength={20}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange("idEstablecimiento", option.key, this.props.form);
                    }}
                  >
                    {this.props.formValues.establecimientos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            {this.props.formValues.idTipo == 2 ? (
              <div className="col-md-4 form-group">
                <Form.Item label="Tipo Almacén">
                  {getFieldDecorator("idTipoAlmacen", {
                    initialValue: this.props.formValues.idTipoAlmacen
                      ? { key: this.props.formValues.idTipoAlmacen }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Tipo Almacén"}
                      optionFilterProp="children"
                      loading={this.props.form.almacenLoading}
                      onChange={(option) =>
                        this.props.onChange(
                          "idTipoAlmacen",
                          option.key,
                          this.props.form
                        )
                      }
                    >
                      {this.props.formValues.tipoAlmacen.map((item) => (
                        item.codigo == '000002' ?
                          <Option key={item.id} value={item.id}> {item.nombre}
                          </Option> : null
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>

            ) : null}



            {this.props.formValues.idTipo == 2 ? (

              <div className="col-md-4 form-group">
                <Form.Item label="Almacén">
                  {getFieldDecorator("idAlmacen", {
                    initialValue: this.props.formValues.idAlmacen
                      ? { key: this.props.formValues.idAlmacen }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Almacén"}
                      optionFilterProp="children"
                      loading={this.props.form.almacenLoading}
                      onChange={(option) =>
                        this.props.onChange(
                          "idAlmacen",
                          option.key,
                          this.props.form
                        )
                      }
                    >
                      {this.props.formValues.almacenes.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            ) : null}


            {this.props.formValues.idTipoComprobante == 8 ? (
              <div className="col-md-4 form-group">

                <Form.Item label="Motivo">
                  {getFieldDecorator("idMotivo", {
                    initialValue: this.props.formValues.idMotivo
                      ? { key: this.props.formValues.idMotivo }
                      : undefined,
                  })(
                    <Select
                      showSearch
                      disabled={this.props.isPendiente}
                      labelInValue
                      placeholder={"Seleccione Motivo"}
                      optionFilterProp="children"
                      onChange={(option) => this.props.onChange("idMotivo", option.key, this.props.form)}
                    >
                      {this.props.formValues.motivos.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>

              </div>
            ) : null
            }

          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Observación">
                {getFieldDecorator('observacion', {
                  initialValue: this.props.formValues.observacion
                })(
                  <TextArea
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                tabBarExtraContent={
                  <div className="custom-options">

                    {this.props.formValues.idTipo == 1 ? (
                      <Button
                        icon="plus"
                        type="primary"
                        onClick={() =>
                          this.props.onAgregarItem(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          )
                        }
                      >
                        Item Libre
                      </Button>

                    ) : null}

                    <Button
                      icon="plus"
                      type="primary"
                      onClick={() =>
                        this.props.onAgregarDetalle(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Agregar
                    </Button>

                  </div>
                }
              >
                <TabPane
                  tab={
                    <span>
                      <Icon type="ordered-list" />
                      Detalle de Productos y Servicios
                    </span>
                  }
                  key="1"
                >
                  <Productos
                    dataSource={this.props.formValues.listaCompraDetalle}
                    onRemove={this.handleRemoverProducto}
                    onEditarNombreProducto={this.props.onEditarNombreProducto}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onSetFieldsValue={setFieldsValue}
                    onGetFieldValue={getFieldValue}
                  />
                </TabPane>

              </Tabs>
            </div>
          </div>
          <Footer
            formValues={this.props.formValues}
            onChangeTotals={this.handleChangeTotals}
            onGetFieldDecorator={getFieldDecorator}
            onGetFieldValue={getFieldValue}
          />
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(FormModalCompra);